<template lang="html">
  <div class="container-fluid">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
     <div class="col-sm p-0">
       <div class="andalinpoints">
         <div class="global__wrapper">
           <Voucher></Voucher>
           <Faq class="mt-3"></Faq>
         </div>
       </div>
     </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
import Voucher from '@/components/andalinpoint/Vouchers.vue'
import Faq from '@/components/andalinpoint/Faq.vue'
import mixin from '@/mixin'

export default {
  name: 'andalinpoints',
  mixins: [mixin],
  components: {
    Sidebar,
    Voucher,
    Faq
  },
  mounted () {
    if (!this.canAccessAndalinPoints()) {
      this.$router.push({ name: 'Dashboard' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/andalinPoints/index.vue